import { useEffect, useState } from "react";
import { ScrollText, RefreshCw } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { toast } from "sonner";

const ACTION_LABELS = {
  admin_created: "Admin creado",
  admin_updated: "Admin actualizado",
  admin_deleted: "Admin eliminado",
  admin_password_reset: "Reset de contraseña",
};

const tsFmt = (s) => {
  const d = new Date(s);
  return d.toLocaleString("es", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export default function AuditTab() {
  const auth = useAdminAuth();
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => {
    setBusy(true);
    auth.apiGet("/admin/audit?limit=200")
      .then((r) => setItems(r.data || []))
      .catch((e) => toast.error(e?.response?.data?.detail || "Sin permiso"))
      .finally(() => setBusy(false));
  };
  useEffect(load, [auth]); // eslint-disable-line

  return (
    <div data-testid="tab-audit" className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">◊ Bitácora de auditoría · {items.length} eventos</p>
        <button onClick={load} disabled={busy} data-testid="audit-refresh" className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-ink text-cream hover:bg-coral transition disabled:opacity-50">
          <RefreshCw className={`w-3.5 h-3.5 ${busy ? "animate-spin" : ""}`} /> Refrescar
        </button>
      </div>

      <section className="border hairline bg-cream-card rounded-2xl p-3 md:p-5 divide-y">
        {items.length === 0 && <p className="text-center text-sm text-ink-mid py-8" data-testid="audit-empty">Sin eventos registrados.</p>}
        {items.map((e) => (
          <div key={e.id} data-testid={`audit-${e.id}`} className="grid grid-cols-12 gap-3 px-3 py-3 items-start">
            <div className="col-span-12 md:col-span-2 text-[11px] font-mono text-ink-mid">{tsFmt(e.created_at)}</div>
            <div className="col-span-6 md:col-span-3">
              <p className="text-sm font-medium">{e.actor_email}</p>
              <p className="text-[10px] text-ink-mid font-mono uppercase tracking-wider">{e.actor_role}</p>
            </div>
            <div className="col-span-6 md:col-span-2">
              <span className="px-2 py-0.5 rounded-full bg-coral/10 text-coral font-mono uppercase tracking-wider text-[10px]">
                {ACTION_LABELS[e.action] || e.action}
              </span>
            </div>
            <div className="col-span-6 md:col-span-3 text-xs font-mono break-all">{e.target}</div>
            <div className="col-span-6 md:col-span-2 text-[11px] text-ink-mid">
              {e.meta && Object.keys(e.meta).length > 0 ? Object.entries(e.meta).map(([k, v]) => (<span key={k} className="font-mono">{k}: {Array.isArray(v) ? v.join(",") : String(v)}{" "}</span>)) : "—"}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
